import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { globalVariablesServer } from '../globals';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export class Student {
  cnt1: string;
  cnt2: string;
  cnt3: string;
}

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private headers: HttpHeaders;
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT"

    });
  }



  ShowPage(id) {  
    //return this.http.get<User[]>(globalVariablesServer.apiurl + 'api/ApiDashboard/ShowAllData', { headers: this.headers })
    console.log("id",id)
    return this.http.post(globalVariablesServer.apiurl + 'api/ApiDashboard/ShowAllData',Number(id), { headers: this.headers });

   

  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

}
